import { render, staticRenderFns } from "./IbxAsmtItemValidation.vue?vue&type=template&id=5f743210"
import script from "./IbxAsmtItemValidation.vue?vue&type=script&lang=ts"
export * from "./IbxAsmtItemValidation.vue?vue&type=script&lang=ts"
import style0 from "./IbxAsmtItemValidation.vue?vue&type=style&index=0&id=5f743210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports